import _jsx from "@babel/runtime-corejs3/helpers/esm/jsx";

var _i, _ShowMessage;

/*
 * Copyright (C) 2020 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from '../../../../format-message';
import { SimpleSelect } from '@instructure/ui-simple-select';
import { View } from '@instructure/ui-view';
import { TextInput } from '@instructure/ui-text-input';

const ShowCreativeCommonsOptions = _ref => {
  let {
    ccLicense,
    setCCLicense,
    licenseOptions
  } = _ref;
  const onlyCC = licenseOptions.filter(license => license.id.indexOf('cc') === 0);
  return /*#__PURE__*/_jsx(View, {
    as: "div",
    margin: "medium 0"
  }, void 0, /*#__PURE__*/_jsx(SimpleSelect, {
    renderLabel: formatMessage('Creative Commons License:'),
    assistiveText: formatMessage('Use arrow keys to navigate options.'),
    value: ccLicense,
    onChange: (e, _ref2) => {
      let {
        id
      } = _ref2;
      return setCCLicense(id);
    }
  }, void 0, onlyCC.map(license => /*#__PURE__*/_jsx(SimpleSelect.Option, {
    id: license.id,
    value: license.id
  }, license.id, license.name))));
};

const ShowMessage = () => {
  return /*#__PURE__*/_jsx("div", {
    className: "alert"
  }, void 0, /*#__PURE__*/_jsx("span", {}, void 0, _i || (_i = /*#__PURE__*/_jsx("i", {
    className: "icon-warning"
  })), /*#__PURE__*/_jsx("span", {
    style: {
      paddingLeft: '10px'
    }
  }, void 0, formatMessage("If you do not select usage rights now, this file will be unpublished after it's uploaded."))));
};

const UsageRightsSelectBox = _ref3 => {
  let {
    contextType,
    contextId,
    showMessage: showMessageProp,
    usageRightsState,
    setUsageRightsState
  } = _ref3;
  const {
    usageRight,
    ccLicense,
    copyrightHolder
  } = usageRightsState;
  const [licenseOptions, setLicenseOptions] = React.useState([]);
  const [showMessage, setShowMessage] = React.useState(showMessageProp);
  const CONTENT_OPTIONS = [{
    display: formatMessage('Choose usage rights...'),
    value: 'choose'
  }, {
    display: formatMessage('I hold the copyright'),
    value: 'own_copyright'
  }, {
    display: formatMessage('I have obtained permission to use this file.'),
    value: 'used_by_permission'
  }, {
    display: formatMessage('The material is in the public domain'),
    value: 'public_domain'
  }, {
    display: formatMessage('The material is subject to an exception - e.g. fair use, the right to quote, or others under applicable copyright laws'),
    value: 'fair_use'
  }, {
    display: formatMessage('The material is licensed under Creative Commons'),
    value: 'creative_commons'
  }];
  React.useEffect(() => {
    function apiUrl() {
      const context = contextType.replace(/([^s])$/, '$1s'); // pluralize

      return `/api/v1/${context}/${contextId}/content_licenses`;
    }

    (function () {
      fetch(apiUrl()).then(res => res.text()).then(res => setLicenseOptions(JSON.parse(res))).catch(() => {});
    })();
  }, [contextType, contextId]);

  function handleChange(value) {
    setUsageRightsState(state => ({ ...state,
      usageRight: value
    }));
    setShowMessage(showMessageProp && value === 'choose');
  }

  return /*#__PURE__*/_jsx(View, {
    as: "div"
  }, void 0, /*#__PURE__*/_jsx(View, {
    as: "div",
    margin: "medium 0"
  }, void 0, /*#__PURE__*/_jsx(SimpleSelect, {
    renderLabel: formatMessage('Usage Right:'),
    assistiveText: formatMessage('Use arrow keys to navigate options.'),
    onChange: (e, _ref4) => {
      let {
        id
      } = _ref4;
      handleChange(id);
    },
    value: usageRight
  }, void 0, CONTENT_OPTIONS.map(contentOption => /*#__PURE__*/_jsx(SimpleSelect.Option, {
    id: contentOption.value,
    value: contentOption.value
  }, contentOption.value, contentOption.display)))), usageRight === 'creative_commons' && /*#__PURE__*/_jsx(ShowCreativeCommonsOptions, {
    ccLicese: ccLicense,
    setCCLicense: license => setUsageRightsState(state => ({ ...state,
      ccLicense: license
    })),
    licenseOptions: licenseOptions
  }), /*#__PURE__*/_jsx(View, {
    as: "div",
    margin: "medium 0"
  }, void 0, /*#__PURE__*/_jsx(TextInput, {
    renderLabel: formatMessage('Copyright Holder:'),
    value: copyrightHolder,
    onChange: (e, value) => setUsageRightsState(state => ({ ...state,
      copyrightHolder: value
    })),
    placeholder: formatMessage('(c) 2001 Acme Inc.')
  })), /*#__PURE__*/_jsx(View, {
    as: "div",
    margin: "medium 0"
  }, void 0, showMessage && (_ShowMessage || (_ShowMessage = /*#__PURE__*/_jsx(ShowMessage, {})))));
};

export default UsageRightsSelectBox;